export const passwordRegex =
  /* eslint-disable-next-line */
  /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])[a-zA-Z0-9- ?!@|>'"<\[\]()£=#$%^;:+_&%&@±§.,*\/\\]{6,20}$/;
  // /^(?=.*[0-9])(?=.*[-?!@|>'"<\[\]()£=#$%^;:+_&%&@±§.,*\/\\])(?=.*[A-Z])(?=.*[a-z])[a-zA-Z0-9- ?!@|>'"<\[\]()£=#$%^;:+_&%&@±§.,*\/\\]{6,20}$/;
// /^(?!.*(?:012|123|234|345|456|567|678|789|890))(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{12,20}$/;
